<template>
  <div class="section-main__warp">
    <div class="fuel-use">
      <div class="left">
        <div class="title-row">
          <div class="title">燃料消耗</div>
          <div class="btn">
            <el-tooltip class="item" effect="dark" content="新增" placement="top" popper-class="tooltip-draw">
              <el-button type="text" @click="addshow"><i class="el-icon-circle-plus-outline btn-sty"></i></el-button>
            </el-tooltip>
          </div>
        </div>
        <div class="content">
          <el-table ref="fuelTable" :show-header="false" :data="fuelData" highlight-current-row
            @row-click="handleRowClick">
            <el-table-column prop="fuelName"></el-table-column>
            <el-table-column align="right">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
                  <el-button type="text" @click="updateShow(scope.row)"><i class="el-icon-edit-outline"
                      style="font-size: 16px;"></i></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw">
                  <el-button type="text" @click="delShow(scope.row)"><i class="el-icon-delete"
                      style="font-size: 16px;"></i></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="right">
        <fuelUse ref="fuelUse"></fuelUse>
      </div>
    </div>
    <el-dialog :title="fuelTitle" :visible.sync="fuelVisible" width="30%" :close-on-click-modal="closeModal">
      <el-form :model="fuelForm" :rules="fuelRules" ref="fuelForm" label-width="100px">
        <el-form-item label="燃料名称" prop="fuelName">
          <el-input v-model="fuelForm.fuelName" clearable placeholder="请输入燃料名称"></el-input>
        </el-form-item>
        <el-form-item label="燃料种类" prop="fuelType">
          <el-select v-model="fuelForm.fuelType" clearable placeholder="请选择燃料种类" style="width: 100%;">
            <el-option v-for="item in fuelTypeArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标准因子" prop="fuelId">
          <el-select v-model="fuelForm.fuelId" clearable placeholder="请选择标准因子" style="width: 100%;">
            <el-option v-for="item in standardArr" :key="item.fuelId" :label="item.fuelName"
              :value="item.fuelId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="fuelRemark">
          <el-input v-model="fuelForm.fuelRemark" type="textarea" :rows="2" clearable placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fuelConfirm('fuelForm')">确 定</el-button>
        <el-button @click="fuelCancel('fuelForm')">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
import fuelUse from './fuelUse.vue'
export default {
  components: {
    fuelUse
  },
  data() {
    return {
      fuelData: [],
      standardArr: [],
      fuelTypeArr: [{ 'label': '油', 'value': '1' }, { 'label': '气', 'value': '2' }],
      fuelVisible: false,
      closeModal: false,
      fuelTitle: '新增',
      fuelRules: {
        fuelName: [
          { required: true, message: '请输入燃料名称', trigger: ['blur', 'change'] }
        ],
        fuelType: [
          { required: true, message: '请选择燃料种类', trigger: ['blur', 'change'] }
        ],
        fuelId: [
          { required: true, message: '请选择标准因子', trigger: ['blur', 'change'] }
        ],
      },
      fuelForm: {
        id: null,
        fuelName: '',
        fuelType: '',
        fuelId: '',
        fuelRemark: ''
      }
    }
  },
  created() {
    this.getList()
    this.getStandardList()
  },
  methods: {
    handleRowClick(row) {
      this.$refs.fuelUse.getList(row.id, row.fuelType)
    },
    getStandardList() {
      let params = {
        pageNumber: 1,
        pageSize: 10000
      };
      this.$fetch(api.fuelRelated.queryFuelList, params).then((response) => {
        if (response.success) {
          this.standardArr = response.returnObj.list;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    getList() {
      this.$fetch(api.fuelConsumption.queryFuel, {}).then((response) => {
        if (response.success) {
          this.fuelData = response.returnObj;
          this.$refs.fuelTable.setCurrentRow(this.fuelData[0])
          this.$refs.fuelUse.getList(this.fuelData[0].id, this.fuelData[0].fuelType)
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    addshow() {
      this.fuelTitle = '新增燃料'
      this.fuelForm.id = null
      this.fuelForm.fuelName = ''
      this.fuelForm.fuelType = ''
      this.fuelForm.fuelId = ''
      this.fuelForm.fuelRemark = ''
      this.fuelVisible = true
    },
    updateShow(data) {
      this.fuelTitle = '修改燃料'
      this.fuelForm.id = data.id
      this.fuelForm.fuelName = data.fuelName
      this.fuelForm.fuelType = data.fuelType
      this.fuelForm.fuelId = data.fuelId
      this.fuelForm.fuelRemark = data.fuelRemark
      this.fuelVisible = true
    },
    fuelConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.fuelForm.id) {
            let params = {
              id: this.fuelForm.id,
              fuelId: this.fuelForm.fuelId,
              fuelName: this.fuelForm.fuelName,
              fuelType: this.fuelForm.fuelType,
              fuelRemark: this.fuelForm.fuelRemark
            }
            this.$fetch(api.fuelConsumption.updateFuel, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.fuelVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          } else {
            let params = {
              fuelId: this.fuelForm.fuelId,
              fuelName: this.fuelForm.fuelName,
              fuelType: this.fuelForm.fuelType,
              fuelRemark: this.fuelForm.fuelRemark
            }
            this.$fetch(api.fuelConsumption.addFuel, params).then((response) => {
              if (response.success) {
                this.$message.success(response.msgContent)
                this.fuelVisible = false
                this.getList()
              } else {
                this.$message.error(response.msgContent);
              }
            });
          }
        }
      })
    },
    fuelCancel(formName) {
      this.$refs[formName].resetFields();
      this.fuelVisible = false
    },
    // 删除
    delShow(row) {
      let params = {
        id: row.id
      }
      this.$confirm("您确定要删除此条数据吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.fuelConsumption.delFuel, params).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getList()
        });
      });
    }
  }
}
</script>

<style>
.fuel-use .el-table__body td.el-table__cell {
  cursor: pointer;
}

.fuel-use .el-table__body tr.current-row>td.el-table__cell {
  background-color: rgb(215, 232, 255);
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.fuel-use {
  width: 100%;
  height: 100%;
  display: flex;

  .left {
    width: 300px;
    height: 100%;
    background-color: #ffffff;

    .title-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .title {
      margin: 16px 0 16px 16px;
      border-left: 5px solid #407aee;
      padding-left: 10px;
      font-size: 16px;
    }

    .btn {
      margin-right: 20px;

      .btn-sty {
        font-size: 22px;
      }
    }

    .content {
      padding: 20px 10px 20px 20px;
    }
  }

  .right {
    flex: 1;
    margin-right: -16px;
    height: 100%;
  }
}
</style>